import React from "react";
import { WHY } from "@/data/content";

export const WhyChoose = () => {
  return (
    <section id="why" data-testid="why-section" className="py-24 md:py-32 bg-[#0A0A0A]">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#D86C1E] mb-4">
              Why Homeowners Choose Schuyler
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl font-black tracking-tight leading-tight text-white">
              A Name You Can Actually Trust
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-white/60">
              Anyone can put a roof over your head. Schuyler earns the right to put one over your
              family's.
            </p>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {WHY.map((w, i) => (
              <div
                key={w.title}
                data-testid={`why-card-${i}`}
                className="bg-[#0A0A0A] p-8 group hover:bg-[#141414] transition-colors"
              >
                <div className="font-heading text-5xl font-black text-white/10 group-hover:text-[#D86C1E]/40 transition-colors">
                  0{i + 1}
                </div>
                <h3 className="font-heading text-xl font-bold text-white mt-4 mb-3">
                  {w.title}
                </h3>
                <p className="text-sm leading-relaxed text-white/60">{w.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
